// import Vue from "vue";
// import Vuex from "vuex";
// Vue.use(Vuex);

// const store = new Vuex.Store({
//   state: {
//     // 存储token
//     Authorization: localStorage.getItem("Authorization")
//       ? localStorage.getItem("Authorization")
//       : ""
//   },

//   mutations: {
//     // 修改token，并将token存入localStorage
//     changeLogin(state, user) {
//       state.Authorization = user.Authorization;
//       localStorage.setItem("Authorization", user.Authorization);
//     }
//   }
// });

// export default store;


import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'

Vue.use(Vuex);

const Store = new Vuex.Store({
	state,
	mutations,
	getters,
	actions,
	strict: false
});

export default Store
